/**
 * The reference (`requestId`) of the last failed admin API call in this tab — attached to a
 * "Report a problem" message (T11-47) so IT finds the service log line. Only the id; never the
 * request or the answer.
 */
let last: string | null = null;

export function rememberRequestId(requestId: string | null | undefined): void {
  if (requestId) {
    last = requestId;
  }
}

export function lastRequestId(): string | null {
  return last;
}
